/**
 * GravityFalls React App Entry Point
 *
 * This file mounts the React application to the #training-planner DOM element
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { AppErrorBoundary } from './App';
import './index.css';

// Get the app container
const container = document.getElementById('training-planner');

if (container) {
  // Create root and render app
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </React.StrictMode>
  );
} else {
  console.error('Training Planner: Could not find #training-planner container');
}
